import { render, staticRenderFns } from "./PointNetridecashCancel.vue?vue&type=template&id=4794ecb7"
import script from "./PointNetridecashCancel.vue?vue&type=script&lang=js"
export * from "./PointNetridecashCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports